import "./App.css";
import { GridTable } from "./components/GridTable";

function App() {
  return <GridTable />;
}

export default App;
